module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "size": "full"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.isEditData === 0 ? '修改保存中。。。' : '新增保存中。。。'
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form', {
    ref: "pInfo1",
    attrs: {
      "model": _vm.pInfo1,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "guid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "guid,修改时用"
    },
    model: {
      value: (_vm.pInfo1.guid),
      callback: function($$v) {
        _vm.pInfo1.guid = $$v
      },
      expression: "pInfo1.guid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "归类1"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "显示到最上方的类别"
    },
    model: {
      value: (_vm.pInfo1.type1),
      callback: function($$v) {
        _vm.pInfo1.type1 = $$v
      },
      expression: "pInfo1.type1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "归类2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "备用，尚未用到"
    },
    model: {
      value: (_vm.pInfo1.type2),
      callback: function($$v) {
        _vm.pInfo1.type2 = $$v
      },
      expression: "pInfo1.type2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "关键词"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "会显示到类别1的下方"
    },
    model: {
      value: (_vm.pInfo1.keyword),
      callback: function($$v) {
        _vm.pInfo1.keyword = $$v
      },
      expression: "pInfo1.keyword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "此处文字会显示到正文中，可写可不写，最好写上"
    },
    model: {
      value: (_vm.pInfo1.title),
      callback: function($$v) {
        _vm.pInfo1.title = $$v
      },
      expression: "pInfo1.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "原作者"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "原作者"
    },
    model: {
      value: (_vm.pInfo1.author2),
      callback: function($$v) {
        _vm.pInfo1.author2 = $$v
      },
      expression: "pInfo1.author2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "答案类型"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "0为输入，1为单选题，2为多选题"
    },
    model: {
      value: (_vm.pInfo1.atype),
      callback: function($$v) {
        _vm.pInfo1.atype = $$v
      },
      expression: "pInfo1.atype"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "答案标记"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "即显示在输入答案前的提示，同时也是选择题选项"
    },
    model: {
      value: (_vm.pInfo1.amark),
      callback: function($$v) {
        _vm.pInfo1.amark = $$v
      },
      expression: "pInfo1.amark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "答案是否数值"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "数值为1，字符为0，逗号分隔，，如果是多个输入，需要全写，如三个是1,1,1"
    },
    model: {
      value: (_vm.pInfo1.aisnumber),
      callback: function($$v) {
        _vm.pInfo1.aisnumber = $$v
      },
      expression: "pInfo1.aisnumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "答案格式"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "答案格式，如输入一个整数，输入一个字符，输入一个小数，保留两位小数等，多个用逗号分隔"
    },
    model: {
      value: (_vm.pInfo1.aformat),
      callback: function($$v) {
        _vm.pInfo1.aformat = $$v
      },
      expression: "pInfo1.aformat"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "答案"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "答案"
    },
    model: {
      value: (_vm.pInfo1.answer),
      callback: function($$v) {
        _vm.pInfo1.answer = $$v
      },
      expression: "pInfo1.answer"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "主题号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "主题号，知识点大题号"
    },
    model: {
      value: (_vm.pInfo1.main),
      callback: function($$v) {
        _vm.pInfo1.main = $$v
      },
      expression: "pInfo1.main"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "次题号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "次题号，知识点内小题号"
    },
    model: {
      value: (_vm.pInfo1.minor),
      callback: function($$v) {
        _vm.pInfo1.minor = $$v
      },
      expression: "pInfo1.minor"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "等级点"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "等级变化点，24k为1，23k为2，22k为3...."
    },
    model: {
      value: (_vm.pInfo1.rank),
      callback: function($$v) {
        _vm.pInfo1.rank = $$v
      },
      expression: "pInfo1.rank"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "keyword2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "用于生成静态页面的keywords，尽量多填"
    },
    model: {
      value: (_vm.pInfo1.keyword2),
      callback: function($$v) {
        _vm.pInfo1.keyword2 = $$v
      },
      expression: "pInfo1.keyword2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "用于生成静态页面的description，尽量多填"
    },
    model: {
      value: (_vm.pInfo1.description),
      callback: function($$v) {
        _vm.pInfo1.description = $$v
      },
      expression: "pInfo1.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "动画JS名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "只写名称如12k_pid_6,forward_1等，不加.js，多个用逗号分隔"
    },
    model: {
      value: (_vm.pInfo1.animateJSNames),
      callback: function($$v) {
        _vm.pInfo1.animateJSNames = $$v
      },
      expression: "pInfo1.animateJSNames"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "flex",
      "align": "middle",
      "justify": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.closeDlg
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.showEditBtn) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveEdit
    }
  }, [_vm._v("保存修改")]) : _vm._e(), _vm._v(" "), (_vm.type == 0) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.examine1
    }
  }, [_vm._v("创建新题目，审核通过")]) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "flex",
      "align": "middle",
      "justify": "center"
    }
  }, [(_vm.type == 0) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateLastProblemU
    }
  }, [_vm._v("更新已做到最后一题的用户")]) : _vm._e(), _vm._v(" "), (_vm.type == 0) ? _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.commit2knowledge
    }
  }, [_vm._v("提交本题到知识点")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v("\n         \n      ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-row', [_c('span', [_vm._v("题目内容")])]), _vm._v(" "), _c('el-row', [_c('div', {
    staticStyle: {
      "margin": "10px auto",
      "max-width": "100%"
    },
    attrs: {
      "id": "standalone-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "toolbar"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "calc(100vh - 220px)"
    },
    attrs: {
      "id": "editor"
    }
  })])])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b902658"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/examineProblemDlg/src/main.vue
// module id = 503
// module chunks = 2 4